import { environment, API_KEY } from "../operations/environment";

export * from "./envryption";
// export * from "./getHeaderConfig";
// export * from "./isValidJWT";

export const API_HEADER = {
  "Content-Type": "application/json;charset=UTF-8",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Headers": "*",
  "x-api-key": API_KEY,
};

export const ENVIRONMENT_TYPE = {
  LOCAL: "local",
  DEV: "development",
  PRODUCTION: "production",
  STAGING: "staging",
  TEST: "test",
};

export function consoleLog(data) {
  if (environment === ENVIRONMENT_TYPE.PRODUCTION) return;
  console.log(data);
}

export const hasSelectedFilters = (filters) => {
  return Object.values(filters).some((value) => value !== "");
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};
